import type { Word, SignVideo, AslDictionaryResult } from "@kys/shared-types";
import { loadAslDictionary } from "../../packages/api-client/asl";

export type ShowcaseCard = {
  id: string;
  word: Word;
  video?: SignVideo;
  src?: string;
  poster: string;
  meaning: string;
};
type Request = <T>(path: string) => Promise<T>;

/** Shared mapping for initial server data and later client searches. */
export function showcaseCards(result: AslDictionaryResult): ShowcaseCard[] {
  return result.variations.map((variation) => ({
    id: variation.id, meaning: variation.meaning, src: variation.url,
    poster: variation.thumbnail_url || "",
    word: {
      id: `voisea-${result.word}`, en: result.word, zh: "",
      meaning_en: variation.meaning, meaning_zh: "", language_id: "asl",
      category_id: "", tags: [], status: "external", created_at: "", updated_at: "",
      videos: result.variations.length, likes: 0, regions: [], total_count: 1,
      provider: "voisea",
    },
  }));
}

/** Home and Dictionary share the exact API variation IDs, meanings, videos and posters. */
export async function loadShowcase(
  query: string,
  request: Request,
  signal = new AbortController().signal,
): Promise<ShowcaseCard[]> {
  const term = query.trim() || "Hello";
  try {
    const result = await loadAslDictionary(request, term, signal);
    return showcaseCards(result);
  } catch (error) {
    if (error instanceof Error && error.message.toLowerCase() === "not_found")
      return [];
    throw error;
  }
}
